import { useEffect } from 'react';

const usePageTitle = (title) => {
  useEffect(() => {
    const previousTitle = document.title;
    document.title = `${title} | PT. Tritunas Putra Nusantara`;
    
    return () => {
      document.title = previousTitle;
    };
  }, [title]);
};

export default usePageTitle;